import { render, staticRenderFns } from "./EdsTile.vue?vue&type=template&id=83b139c2&scoped=true&"
import script from "./EdsTile.vue?vue&type=script&lang=js&"
export * from "./EdsTile.vue?vue&type=script&lang=js&"
import style0 from "./EdsTile.vue?vue&type=style&index=0&id=83b139c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b139c2",
  null
  
)

export default component.exports